module.exports = __webpack_public_path__ + "img/preview-dark.edc1f2c2.png";